'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bolt';
var width = 448;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = ['M48 248l0 24.5 113.8 3.9 20.7 .7L176.6 297 125.1 470.2 400 264l0-24.5-113.8-3.9-20.7-.7 5.9-19.8L322.9 41.9 48 248z', 'M291.4 203.7l52.9-178L352 0 330.5 16.1 32 240l0 48 112.7 3.9 16.5 .6-4.7 15.8-52.9 178L96 512l21.5-16.1L416 272l0-48-112.7-3.9-16.5-.6 4.7-15.8zM400 239.5l0 24.5L125.1 470.2 176.6 297l5.9-19.8-20.7-.7L48 272.5 48 248 322.9 41.9 271.4 215l-5.9 19.8 20.7 .7L400 239.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;